import {
  Component,
  ComponentFactoryResolver,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { SuccessComponent } from 'src/app/components/shared/components/success/success.component';
import { ComponentValueDirective } from 'src/app/modules/case/componentValue.directive';
import { COMPONENTSX } from '../../constants/components.constant';
import { ICase } from '../../interfaces/case.interface';
import { CasesService } from '../../../../core/services/cases.service';

@Component({
  selector: 'app-finishCase',
  templateUrl: './finishCase.component.html',
  styleUrls: ['./finishCase.component.scss'],
})
export class FinishCaseComponent implements OnInit {
  constructor(
    private readonly casesService: CasesService,
    private readonly dialogRef: MatDialogRef<FinishCaseComponent>,
    private readonly fb: FormBuilder,
    private readonly dialog: MatDialog,
    public snackbar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: ICase,
    private componentFactoyResolver: ComponentFactoryResolver
  ) {}
  @ViewChild(ComponentValueDirective, { static: false })
  component!: ComponentValueDirective;
  emiteTareaGuardadaAlComponenteDinamico: Subject<void> = new Subject<void>();
  ngOnInit() {
    this.findComponentBeforeFinalize();
  }

  form = this.fb.group({
    observations: [''],
    data: [undefined],
  });

  components = COMPONENTSX;
  componentRef: any;
  ComponentValue = null;
  private timeOut: any;

  closeModal() {
    this.dialogRef.close();
  }

  isLoading = false;

  alert(message) {
    this.dialog.open(SuccessComponent, {
      data: { title: message },
    });
  }

  findComponentBeforeFinalize() {
    const findIndex = this.components.findIndex(
      (component) => component.value === this.data.caseType.component
    );
    if (findIndex !== -1) {
      this.ComponentValue = this.components[findIndex];
      this.timeOut = setTimeout(() => {
        const componentFactoy =
          this.componentFactoyResolver.resolveComponentFactory<{ data: any }>(
            this.ComponentValue.component
          );
        const viewContainerRef = this.component.viewContainerRef;
        viewContainerRef.clear();
        this.componentRef = viewContainerRef.createComponent<{ data: any }>(
          componentFactoy
        );
        // this.componentRef.instance.data = {
        //   task: JSON.parse(JSON.stringify(this.task)),
        //   personType: ' this.caso.personType',
        // };
        this.componentRef.instance.saveEvent$ =
          this.emiteTareaGuardadaAlComponenteDinamico.asObservable();
      }, 10);
    }
  }

  finish() {
    //Si posee BeforeFinalize
    if (this.componentRef) {
      const { form } = this.componentRef.instance;

      if (form) {
        const { value, invalid } = form;
        if (invalid) {
          this.snackbar.open(
            'Error: Debe completar los campos requeridos (*)',
            '❌'
          );
          return;
        }
        this.form.value.data = value;
      }
    }

    this.isLoading = true;
    const body = this.form.value;
    this.casesService.finishCase(this.data._id, body).subscribe({
      next: () => {
        this.isLoading = false;
        this.dialogRef.close(true);
        this.casesService.caseFinished.next(this.data);
        this.emiteTareaGuardadaAlComponenteDinamico.next();
        this.alert('Caso finalizado');
      },
      error: () => {
        this.alert('Ocurrrio un error al intentar finalizar');
        this.isLoading = false;
      },
    });
  }
}
